export const defaultStyle =
  "font-title text-md px-2 block w-full border-solid border-2 rounded-xl p-x2 focus:outline-none ";
export const defaultInputStyle = defaultStyle + "border-indigo-400 h-12 flex-1";
export const defaultSearchStyle =
  defaultStyle + "border-gray-100 h-12 flex-1 text-sm";
export const defaultInputInvalidStyle =
  defaultStyle + "border-red-400 h-12 flex-1";
export const defaultInputLargeStyle = defaultStyle + "border-indigo-400 h-14";
export const defaultInputLargeInvalidStyle =
  defaultStyle + "border-red-400 h-14";
export const defaultSkeletonStyle =
  "px-2 block w-full rounded-2xl p-x2 focus:outline-none skeleton-input-radius ";
export const defaultSkeletonLargeStyle = defaultSkeletonStyle + " h-12";
export const defaultSkeletonNormalStyle = defaultSkeletonStyle + " h-10";
export const defaultInputSmStyle =
  defaultStyle + "border-indigo-300 h-8 text-sm flex-1";
export const defaultInputSmInvalidStyle =
  defaultStyle + "border-red-400 h-8 text-sm flex-1";

// Default Table Styles
export const defaultTdStyle =
  "text-sm sm:text-left text-default-color font-title flex flex-wrap flex-row flex-1 whitespace-nowrap text-ellipsis overflow-hidden mb-1";
export const defaultTdActionStyle =
  "text-sm sm:text-left text-default-color font-title flex flex-row sm:w-11";
export const defaultTdWrapperStyle =
  "w-full flex flex-wrap flex-col sm:flex-row my-2 bg-white rounded-xl py-2 px-3 sm:px-0 sm:py-0";
export const defaultTdContent =
  "sm:w-full w-1/2 flex flex-wrap flex-row items-center";
export const defaultTdContentTitleStyle =
  "sm:hidden w-1/2 flex flex-row items-center";

export const IconStyle = { top: -2, position: "relative", marginRight: 2 };
